import React from "react";
import { AppStateAction, AppStateReducerActionTypes } from "./reducer";

export const onConnectionError = (
  error: any,
  appDispatch: React.Dispatch<AppStateAction>
) => {
  // 1) Logs "reales" para debug
  console.log("=== AXIOS ERROR (raw) ===", error);
  console.log("=== AXIOS ERROR (summary) ===", {
    message: error?.message,
    code: error?.code,
    isAxiosError: error?.isAxiosError,
    url: error?.config?.url,
    method: error?.config?.method,
    timeout: error?.config?.timeout,
    hasResponse: !!error?.response,
    status: error?.response?.status,
    responseData: error?.response?.data,
  });

  // 2) Si vos seteás un error custom en algún lado
  if (error?.custom) {
    appDispatch({
      type: AppStateReducerActionTypes.ERROR_ALERT,
      error_payload: error.custom,
    });
    return;
  }

  // 3) Si el server respondió (4xx/5xx)
  if (error?.response) {
    const backendMessage =
      error?.response?.data?.data?.errorMessage ?? // tu formato: data.data.errorMessage
      error?.response?.data?.error ??              // a veces: data.error
      error?.response?.data?.message ??            // a veces: data.message
      error?.response?.statusText;                 // fallback

    const msg =
      backendMessage ||
      `Error en el servicio (${error.response.status})`;

    appDispatch({
      type: AppStateReducerActionTypes.ERROR_ALERT,
      error_payload: msg,
    });
    return;
  }

  // 4) Request salió pero no hubo respuesta consumible (Network Error, CORS, timeout, etc.)
  if (error?.request) {
    const msg =
      error?.message ||  // suele ser "Network Error" o "timeout of Xms exceeded"
      "Error de conexión";

    appDispatch({
      type: AppStateReducerActionTypes.ERROR_ALERT,
      error_payload: msg,
    });
    return;
  }

  // 5) Fallback final
  appDispatch({
    type: AppStateReducerActionTypes.ERROR_ALERT,
    error_payload: error?.message || "Hubo un error desconocido",
  });
};
